// Get All IDFC Records Constants
export const GET_ALL_IDFC_RECORDS_REQUEST = 'GET_ALL_IDFC_RECORDS_REQUEST'
export const GET_ALL_IDFC_RECORDS_SUCCESS = 'GET_ALL_IDFC_RECORDS_SUCCESS'
export const GET_ALL_IDFC_RECORDS_FAIL = 'GET_ALL_IDFC_RECORDS_FAIL'
export const GET_ALL_IDFC_RECORDS_RESET = 'GET_ALL_IDFC_RECORDS_RESET'

// Create IDFC Record Constants
export const CREATE_IDFC_RECORD_REQUEST = 'CREATE_IDFC_RECORD_REQUEST'
export const CREATE_IDFC_RECORD_SUCCESS = 'CREATE_IDFC_RECORD_SUCCESS'
export const CREATE_IDFC_RECORD_FAIL = 'CREATE_IDFC_RECORD_FAIL'
export const CREATE_IDFC_RECORD_RESET = 'CREATE_IDFC_RECORD_RESET'

// Update IDFC Record Constants
export const UPDATE_IDFC_RECORD_REQUEST = 'UPDATE_IDFC_RECORD_REQUEST'
export const UPDATE_IDFC_RECORD_SUCCESS = 'UPDATE_IDFC_RECORD_SUCCESS'
export const UPDATE_IDFC_RECORD_FAIL = 'UPDATE_IDFC_RECORD_FAIL'
export const UPDATE_IDFC_RECORD_RESET = 'UPDATE_IDFC_RECORD_RESET'

// Delete IDFC Record Constants
export const DELETE_IDFC_RECORD_REQUEST = 'DELETE_IDFC_RECORD_REQUEST'
export const DELETE_IDFC_RECORD_SUCCESS = 'DELETE_IDFC_RECORD_SUCCESS'
export const DELETE_IDFC_RECORD_FAIL = 'DELETE_IDFC_RECORD_FAIL'
export const DELETE_IDFC_RECORD_RESET = 'DELETE_IDFC_RECORD_RESET'

// Import IDFC Records Constants
export const IMPORT_IDFC_RECORDS_REQUEST = 'IMPORT_IDFC_RECORDS_REQUEST'
export const IMPORT_IDFC_RECORDS_SUCCESS = 'IMPORT_IDFC_RECORDS_SUCCESS'
export const IMPORT_IDFC_RECORDS_FAIL = 'IMPORT_IDFC_RECORDS_FAIL'
export const IMPORT_IDFC_RECORDS_RESET = 'IMPORT_IDFC_RECORDS_RESET'

// Export IDFC Records Constants
export const EXPORT_IDFC_RECORDS_REQUEST = 'EXPORT_IDFC_RECORDS_REQUEST'
export const EXPORT_IDFC_RECORDS_SUCCESS = 'EXPORT_IDFC_RECORDS_SUCCESS'
export const EXPORT_IDFC_RECORDS_FAIL = 'EXPORT_IDFC_RECORDS_FAIL'
export const EXPORT_IDFC_RECORDS_RESET = 'EXPORT_IDFC_RECORDS_RESET'


export const BULK_DELETE_IDFC_RECORDS_REQUEST = 'BULK_DELETE_IDFC_RECORDS_REQUEST'
export const BULK_DELETE_IDFC_RECORDS_SUCCESS = 'BULK_DELETE_IDFC_RECORDS_SUCCESS'
export const BULK_DELETE_IDFC_RECORDS_FAIL = 'BULK_DELETE_IDFC_RECORDS_FAIL'
export const BULK_DELETE_IDFC_RECORDS_RESET = 'BULK_DELETE_IDFC_RECORDS_RESET'


// Add these constants at the end of the file
export const SYNC_IDFC_TASK_STATUS_REQUEST = 'SYNC_IDFC_TASK_STATUS_REQUEST';
export const SYNC_IDFC_TASK_STATUS_SUCCESS = 'SYNC_IDFC_TASK_STATUS_SUCCESS';
export const SYNC_IDFC_TASK_STATUS_FAIL = 'SYNC_IDFC_TASK_STATUS_FAIL';
export const SYNC_IDFC_TASK_STATUS_RESET = 'SYNC_IDFC_TASK_STATUS_RESET';